import React from 'react'
import PropTypes from 'prop-types'
import { Body16 } from 'components/Typography'
import theme from 'styles/theme'
import {
  ProductCardHeading,
  ProductCardBottomContainer,
} from './ProductCardInfo.style'
import ProductCardPriceInfo from '../ProductCardPriceInfo'

const ProductCardInfo = ({
  brand,
  productBrandNameOverride,
  currency,
  description,
  rrpPrice,
  salePrice,
  villagePrice,
  labels,
  selected,
  hasBackgroundHex,
}) => {
  return (
    <ProductCardBottomContainer selected={selected}>
      <ProductCardPriceInfo
        {...{
          currency,
          rrpPrice,
          salePrice,
          villagePrice,
          labels,
          selected,
          hasBackgroundHex,
        }}
      />

      <Body16
        color={hasBackgroundHex ? theme.colors.white : theme.colors.sagedark}
        pt={theme.space[1]}>
        {productBrandNameOverride || brand}
      </Body16>
      <ProductCardHeading hasBackgroundHex={hasBackgroundHex}>
        {description}
      </ProductCardHeading>
    </ProductCardBottomContainer>
  )
}

ProductCardInfo.propTypes = {
  brand: PropTypes.string.isRequired,
  productBrandNameOverride: PropTypes.string,
  currency: PropTypes.string,
  description: PropTypes.string.isRequired,
  rrpPrice: PropTypes.number,
  salePrice: PropTypes.number,
  villagePrice: PropTypes.number,
  labels: PropTypes.shape({}),
  selected: PropTypes.bool,
  hasBackgroundHex: PropTypes.bool,
}

ProductCardInfo.defaultProps = {
  productBrandNameOverride: '',
  salePrice: null,
  currency: null,
  rrpPrice: null,
  villagePrice: null,
  labels: {},
  selected: false,
  hasBackgroundHex: false,
}

export default ProductCardInfo
